import localStorage from '@/service/storage/localStorageService'
import {LOGIN_USER_INFO, CAPTCHA_TOKEN} from "@/service/keys";

export function getAccessToken() {
  const loginUser = localStorage.getObj(LOGIN_USER_INFO)
  if (!loginUser) {
    return ''
  }
  return loginUser.accessToken
}
export function getLoginUser() {
  const obj = localStorage.getObj(LOGIN_USER_INFO);
  if (obj) {
    return obj.user
  }
  return null;
}
